module.exports = __webpack_public_path__ + "img/cart1.c9ed7d63.png";